import { Container, Flex, Text, useDisclosure } from '@chakra-ui/react';

import { useMatomo } from '@datapunt/matomo-tracker-react';
import { MenuFiltered } from 'components/listing/MenuFiltered';
import { MenuFull } from 'components/listing/MenuFull';
import { PizzassistantDrawer } from 'components/main';
import { useAppDataContext } from 'misc/appDataCtxt';
import { ReactQueryKey } from 'misc/enums';
import { getAll } from 'misc/getAllPizzas';
import type { NextPage } from 'next';
import Head from 'next/head';
import React, { useEffect } from 'react';
import { useQuery } from 'react-query';

const Listing: NextPage = () => {
  const { trackPageView } = useMatomo();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { state } = useAppDataContext();
  const {
    isLoading,
    isError,
    data: pizzas,
    error,
  } = useQuery(ReactQueryKey.allPizzas, getAll);

  useEffect(() => {
    trackPageView({ documentTitle: 'Pizza Listing' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Head>
        <title>Toutes nos Pizzas</title>
        <meta name="description" content={`Toutes nos Pizzas !`} />
      </Head>

      <Container p={1}>
        {isLoading && <Text>loading...</Text>}

        {isError && error instanceof Error && (
          <Text>
            error of type {error.name}: {error.message}
          </Text>
        )}

        {!pizzas ? (
          <Text>No pizzas 🤔 ?</Text>
        ) : (
          <>
            <Flex
              direction={'column'}
              wrap={'wrap'}
              justifyContent={'space-between'}
            >
              {!state.filter ? (
                <MenuFull onOpen={onOpen} pizzas={pizzas} />
              ) : (
                <MenuFiltered
                  onOpen={onOpen}
                  pizzas={pizzas}
                  filters={state.filter}
                />
              )}
            </Flex>
            <PizzassistantDrawer onClose={onClose} isOpen={isOpen} />
          </>
        )}
      </Container>
    </>
  );
};

export default Listing;
